import { useEffect } from "react";
import { Form, Input, InputNumber, DatePicker, Button } from "antd";
import { CloseCircleOutlined } from "@ant-design/icons";
import dayjs from "dayjs";
import "./service-excel.css";

const ServiceExcelSale = ({ record, onSave, onCancel }) => {
  const [form] = Form.useForm();

  useEffect(() => {
    if (record) {
      const initialValues = {
        ...record,
        saleDate: record.saleDate ? dayjs(record.saleDate) : null,
      };
      form.setFieldsValue(initialValues);
    }
  }, [record, form]);

  const handleSave = () => {
    form.validateFields().then(values => {
      const updatedRecord = {
        ...record,
        ...values,
        saleDate: values.saleDate ? values.saleDate.format('YYYY-MM-DD') : null,
      };
      onSave(updatedRecord);
    }).catch(err => {
      console.error('Validation failed:', err);
    });
  };

  if (!record) return null;

  return (
    <div className="sport-modal">
      <div
        className="sport-modal-overlay"
        onMouseDown={(e) => e.target === e.currentTarget && onCancel()}
      >
        <div
          className="sport-modal-content service-excel-modal-content"
          onMouseDown={(e) => e.stopPropagation()}
        >
          <div className="sport-modal-title">
            <span>Редактирование продажи</span>
            <CloseCircleOutlined
              className="sport-section-title-close"
              onClick={onCancel}
            />
          </div>
          <Form
            form={form}
            layout="vertical"
            colon={false}
            labelCol={{ span: 24 }}
            wrapperCol={{ span: 24 }}
          >
            <Form.Item label="Внешний ID" name="externalId">
              <Input placeholder="Внешний ID" />
            </Form.Item>
            <Form.Item label="Дата продажи" name="saleDate">
              <DatePicker
                className="service-excel-datepicker"
                format="DD.MM.YYYY"
                allowClear
              />
            </Form.Item>
            <Form.Item label="Сумма" name="amount">
              <InputNumber
                className="service-excel-inputnumber"
                placeholder="Сумма"
                precision={2}
              />
            </Form.Item>
            <Form.Item label="Оплата" name="payment">
              <InputNumber
                className="service-excel-inputnumber"
                placeholder="Оплата"
                precision={2}
              />
            </Form.Item>
            <Form.Item label="Стоимость" name="cost">
              <InputNumber
                className="service-excel-inputnumber"
                placeholder="Стоимость"
                precision={2}
              />
            </Form.Item>
            <Form.Item label="Скидка" name="discount">
              <InputNumber
                className="service-excel-inputnumber"
                placeholder="Скидка"
                precision={2}
              />
            </Form.Item>
            <Form.Item label="Скидка сумма" name="discountAmount">
              <InputNumber
                className="service-excel-inputnumber"
                placeholder="Скидка сумма"
                precision={2}
              />
            </Form.Item>
            <Form.Item label="Комментарий" name="comment">
              <Input placeholder="Комментарий" />
            </Form.Item>
            <Form.Item label="Внешний ID клиента" name="clientExternalId">
              <InputNumber
                className="service-excel-inputnumber"
                placeholder="Внешний ID клиента"
              />
            </Form.Item>
            <Form.Item label="Внешний ID абонемента" name="abonementExternalId">
              <InputNumber
                className="service-excel-inputnumber"
                placeholder="Внешний ID абонемента"
              />
            </Form.Item>
            <Form.Item>
              <div className="service-excel-modal-actions">
                <Button onClick={onCancel}>Отмена</Button>
                <Button type="primary" onClick={handleSave}>
                  Сохранить
                </Button>
              </div>
            </Form.Item>
          </Form>
        </div>
      </div>
    </div>
  );
};

ServiceExcelSale.displayName = "ServiceExcelSale";

export default ServiceExcelSale;

